import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import './index.css';

import App from './components/App';
import LogIn from './components/LogIn';
import Registry from './components/Registry';

const routes = (
    <BrowserRouter>
        <Switch>
            <Route path="/iniciar-sesion" component={LogIn} exact={true} />
            <Route path="/registro" component={Registry} exact={true} />
            <Route path="/" component={App} />
        </Switch>
    </BrowserRouter>
)

ReactDOM.render(routes, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
